module.exports = __webpack_public_path__ + "static/media/monitor.bd5eb8a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/monitor.svg
// module id = 249
// module chunks = 1